<template>
  <input-widget :model="model" :attribute="attribute" type="select2" :disabled="disabled"
                :display-field="displayFieldFunction" :multiple="multiple"
                :hint="hint" :label="label" :options="options" :items="computedClerks"
                @select2Select="onSelect" @select2Unselect="onUnselect"/>
</template>


<script>
  import InputWidget from "./../components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import i18n from "@/shared/i18n";

  const {mapState} = createNamespacedHelpers('global');

  /**
   * @author Saiat Kalbiev <kalbievich11@gmail.com>
   */
  export default {
    name: "ClerkSelectInputWidget",
    components: {InputWidget},
    props: {
      model: {
        type: Object,
        required: true
      },
      attribute: {
        type: String,
        required: true
      },
      items: {
        type: Array,
        default: () => []
      },
      options: {
        type: Object,
        default: () => {
          return {placeholder: i18n.t('Select Clerk')};
        }
      },
      label: {
        type: [String, Boolean],
        default: null
      },
      hint: {
        type: [Boolean, String],
        default: false
      },
      disabled: {
        type: Boolean,
        default: false
      },
      auction: {
        type: Object,
        default: () => {
          return {}
        }
      },
      multiple: {
        type: Boolean,
        default: false
      },
    },
    computed: {
      ...mapState({
        clerks: state => state.currentUser.branch.clerks,
      }),
      computedClerks() {
        const clerkUuids = this.auction && this.auction.clerks ? this.auction.clerks.map(i => i.uuid) : []
        return this.clerks.filter(i => clerkUuids.includes(i.uuid))
      }
    },
    methods: {
      displayFieldFunction(item) {
        let tmpStr = item.name;

        if (item.languages && item.languages.length > 0) {
          tmpStr = `${tmpStr} - ${item.languages.map(i => i.name).join(', ')}`;
        }

        return tmpStr;
      },
      onSelect(data) {
        this.$emit('select', data);
      },
      onUnselect(data) {
        this.$emit('unselect', data);
      }
    }
  }
</script>

<style scoped>

</style>
